module.exports = __webpack_public_path__ + "img/device.78989958.png";